export default "__VITE_ASSET__CtNJWG9I__"